import { useState, useEffect } from "react";
import { useHistory } from "react-router";
import dayjs from "dayjs";
import axios from "axios";
import useTituloPagina from "../../hooks/tituloPagina";
import { PATHS, PORTAL_PATHS } from "../../utils/constants/constants";
import { cancelarTurnoPaciente } from "../../apiClient/rutes/turnos";

const useMainPage = () => {
  const [cargando, setCargando] = useState(false);
  const [paciente, setPaciente] = useState({});
  const [turnoSeleccionado, setTurnoSeleccionado] = useState({});
  const [abrirModalCancelarReserva, setAbrirModalCancelarReserva] = useState(false);
  const [abrirComprobanteTurno, setAbrirComprobanteTurno] = useState(false);
  const [abrirModalDetalleTurno, setAbrirModalDetalleTurno] = useState(false);
  const [listadoTurnos, setListadoTurnos] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [prestadoresRecientes, setPrestadoresRecientes] = useState([]);
  const [estudios, setEstudios] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const history = useHistory();
  useTituloPagina();

  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const traerPrestadores = async (paciente) => {
    try {
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };
      const response = await axios.get(`${url}Prestadores`, config);
      if (response.data.length !== 0) {
        setPrestadores(response.data);
      }
    } catch (e) {
      mostrarNotificacion(true, "Error al cargar prestadores", "rojo");
    }
  };

  const traerTurnosPaciente = async (paciente) => {
    let turnosFuturos = null;
    let tmpPrestadoresRecientes = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };
    try {
      const servicio = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          } else {
            return null;
          }
        });
      if (servicio !== null) {
        const response = await axios.get(
          `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}&servicio=${servicio[0].codigo}`,
          config
        );
        if (response.data.length !== 0) {
          turnosFuturos = response.data;
          tmpPrestadoresRecientes = response.data;
          // Filtrar solo turnos futuros y pendientes (no cancelados)
          turnosFuturos = turnosFuturos.filter((turno) => {
            return dayjs(new dayjs()).isBefore(dayjs(turno.fecha)) && turno.aCancelar === true;
          });
          turnosFuturos = turnosFuturos.sort((a, b) => {
            const fechaA = dayjs(a.fecha);
            const fechaB = dayjs(b.fecha);
            if (fechaA.isBefore(fechaB)) {
              return -1;
            } else if (fechaA.isAfter(fechaB)) {
              return 1;
            } else {
              const horaA = dayjs(a.hora, "HH:mm:ss");
              const horaB = dayjs(b.hora, "HH:mm:ss");
              if (horaA.isBefore(horaB)) {
                return -1;
              } else if (horaA.isAfter(horaB)) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          turnosFuturos = turnosFuturos.slice(0, 5);
          tmpPrestadoresRecientes = tmpPrestadoresRecientes
            .sort((a, b) => {
              // Primero por fecha descendente
              const fechaDiff = dayjs(b.fecha).diff(dayjs(a.fecha));
              if (fechaDiff !== 0) return fechaDiff;
              // Luego por nombre de prestador
              return a.prestadorNom.localeCompare(b.prestadorNom);
            })
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  (t) =>
                    t.prestadorCod === value.prestadorCod &&
                    t.prestadorNom === value.prestadorNom
                )
            )
            .slice(0, 4)
            .map((turno) => {
              return {
                prestadorCod: turno.prestadorCod,
                prestadorNom: turno.prestadorNom,
                especialidadNom: turno.especialidadNom,
                sedeNom: turno.sedeNom,
                fecha: turno.fecha,
                mutualNom: turno.mutualNom,
              };
            });
        } else {
          turnosFuturos = [];
          tmpPrestadoresRecientes = [];
        }
        setListadoTurnos(turnosFuturos);
        setPrestadoresRecientes(tmpPrestadoresRecientes);
      }
    } catch (e) {
      mostrarNotificacion(true, "Ocurrió un problema al intentar consultar sus proximos turnos", "rojo");
    }
  };

  const traerEstudios = async (paciente) => {
    let estudios = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };
    try {
      const response = await axios.get(`${url}Estudios`, config);
      if (response.data.length !== 0) {
        estudios = response.data;
      }
      estudios = estudios.map((estudio) => {
        return {
          ...estudio,
          text: estudio.nombre,
        };
      });
      setEstudios(estudios);
    } catch (e) {
      mostrarNotificacion(true, "Se produjo un error al consultar l registradas en el sistema", "rojo");
    }
  };

  const TraerServicio = async (paciente) => {
    try {
      let servicioResponse = {};
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };
      servicioResponse = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          }
        });
      setServicios(servicioResponse);
    } catch (e) {}
  };

  const CancelarTurno = async () => {
    try {
      const urlAxioPP = localStorage.getItem("urlAxioPP");
      
      if (!turnoSeleccionado || !turnoSeleccionado.codigo) {
        mostrarNotificacion(true, "No se ha seleccionado ningún turno para cancelar", "rojo");
        return;
      }

      // Usar la nueva función que cancela el turno pero mantiene el historial
      const response = await cancelarTurnoPaciente(
        paciente.token, 
        turnoSeleccionado.codigo,
        urlAxioPP
      );
      
      if (response.status === 200) {
        mostrarNotificacion(true, "El turno se canceló correctamente y está disponible para otros pacientes", "verde");
      } else {
        mostrarNotificacion(true, "Ocurrió un problema al intentar cancelar el turno", "rojo");
      }
    } catch (error) {
      console.error('Error al cancelar turno:', error);
      const mensajeError = error?.response?.data || error?.message || "Error desconocido";
      mostrarNotificacion(true, `Error al cancelar el turno: ${mensajeError}`, "rojo");
    }
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        traerTurnosPaciente(sesion);
        traerEstudios(sesion);
        TraerServicio(sesion);
        traerPrestadores(sesion);
        setPaciente(sesion);
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: PATHS.ERROR });
    }
    setCargando(false);
    // eslint-disable-next-line
  }, []);

  const handleClickRedirigir = (destino) => {
    switch (destino) {
      case "Reservar turno":
        history.push({ pathname: PORTAL_PATHS.RESERVAR_TURNO });
        break;
      // case "Horarios":
      //   history.push({ pathname: PORTAL_PATHS.HORARIOS });
      //   break; // OCULTO POR REQUERIMIENTO
      case "Datos":
        history.push({ pathname: PORTAL_PATHS.DATOS });
        break;
      case "Turnos":
        history.push({ pathname: PORTAL_PATHS.TURNOS });
        break;
      case "Estudios":
        history.push({ pathname: PORTAL_PATHS.ESTUDIOS });
        break;
      case "MisDatos":
        history.push({ pathname: "/portal/MisDatos" });
        break;
      // case "HorariosPrestadores":
      //   history.push({ pathname: PORTAL_PATHS.HORARIOS_PRESTADORES });
      //   break; // OCULTO POR REQUERIMIENTO
      case "Reservar turnos imágenes":
        history.push({ pathname: PORTAL_PATHS.RESERVAR_TURNOS_IMAGENES });
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
  };

  const togleAbrirCerrarCancelarReserva = () => {
    if (abrirModalCancelarReserva) {
      setTurnoSeleccionado({});
    }
    setAbrirModalCancelarReserva(!abrirModalCancelarReserva);
  };

  const handleClickSeleccionarTurno = (turno) => {
    setTurnoSeleccionado(turno);
    setAbrirModalCancelarReserva(true); // Abrir modal de confirmación de cancelación
  };

  const handleClickCancelarReserva = async () => {
    // No limpiar el turno todavía, lo necesitamos para cancelar
    setAbrirModalCancelarReserva(false); // Cerrar modal primero
    setCargando(true);
    await CancelarTurno();
    await traerTurnosPaciente(paciente);
    setTurnoSeleccionado({}); // Limpiar después de cancelar
    setCargando(false);
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "3516183749";
    navigator.clipboard.writeText(phoneNumber);
    mostrarNotificacion(true, "Se ha copiado el numero de telefono a su portapapeles", "");
  };

  const handleClickComprobanteTurno = (turno) => {
    const prestadorEncontrado = prestadores.find(
      (prestador) => turno.prestadorCod === prestador.codigo
    );
    const servicioEncontrado = servicios.find(
      (servicio) => servicio.codigo === 1
    );
    const lugarAtencion =
      (prestadorEncontrado ? prestadorEncontrado.domicilioTurno : null) ||
      (servicioEncontrado ? servicioEncontrado.direccion : "") ||
      "";
    setTurnoSeleccionado({
      codigo: turno.codigo,
      equipoNom: turno.equipoNom,
      especialidadNom: turno.especialidadNom,
      estudioNom: turno.estudioNom,
      fecha: turno.fecha,
      hora: turno.hora,
      mutualNom: turno.mutualNom,
      prestadorNom: turno.prestadorNom,
      servicio: turno.servicio,
      apellido: paciente.apellido,
      nombre: paciente.nombre,
      mutualNombre: paciente.mutualNombre,
      mutualAfiliado: paciente.mutualAfiliado,
      hc: paciente.hc,
      documentoTipoNombre: paciente.documentoTipoNombre,
      documentoNro: paciente.documentoNro,
      celular: paciente.celular,
      email: paciente.email,
      lugarAtencion: lugarAtencion,
      preparacionEstudio: null,
    });
    setAbrirComprobanteTurno(true);
  };

  const togleAbrirCerrarComprobanteTurno = () => {
    if (abrirComprobanteTurno) {
      setTurnoSeleccionado({});
    }
    setAbrirComprobanteTurno(!abrirComprobanteTurno);
  };

  const handleClickReservarTurnoPrestador = async (prestadorCod) => {
    // Extraer el código del prestador si es un objeto
    const codigoPrestador = typeof prestadorCod === 'object' ? prestadorCod.prestadorCod : prestadorCod;
    
    setCargando(true);
    try {
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };
      const response = await axios.get(
        `${url}Prestadores?mutuales=${paciente.mutual}`,
        config
      );
      if (response.data.length !== 0) {
        let prestadores = response.data;
        prestadores = prestadores.filter((prestador) => prestador.vigente === true);
        let edad = dayjs(dayjs()).diff(paciente.nacimiento, "year");
        prestadores = prestadores.filter((prestador) => {
          if (prestador.filtroEdad) {
            if (prestador.edadDesde <= edad && edad <= prestador.edadHasta)
              return prestador;
          } else {
            return prestador;
          }
        });
        if (edad <= 15) {
          prestadores = prestadores.filter((prestador) => [125, 115].includes(prestador.especialidad));
        } else {
          prestadores = prestadores.filter((prestador) => ![125, 115].includes(prestador.especialidad));
        }
        const prestadorEncontrado = prestadores.find((prestador) => prestador.codigo === codigoPrestador);
        if (prestadorEncontrado) {
          // Prestador vigente - mensaje personalizado
          mostrarNotificacion(true, "Prestador vigente, se dirige al calendario de turnos", "verde");
          setTimeout(() => {
            history.push({
              pathname: PORTAL_PATHS.RESERVAR_TURNO,
              state: { prestador: codigoPrestador },
            });
          }, 1500);
        } else {
          // Prestador no vigente o turnos para estudios - mensaje personalizado
          mostrarNotificacion(true, "Prestador no disponible o turnos para estudios, deberá seleccionar una Estudio", "amarillo");
          setTimeout(() => {
            history.push({ pathname: PORTAL_PATHS.RESERVAR_TURNO });
          }, 3000);
        }
      } else {
        mostrarNotificacion(true, "Prestador no disponible o turnos para estudios, seleccionar Estudio", "amarillo");
        setTimeout(() => {
          history.push({ pathname: PORTAL_PATHS.RESERVAR_TURNO });
        }, 2000);
      }
    } catch (e) {
      console.error('[DEBUG] Error en handleClickReservarTurnoPrestador:', e);
      mostrarNotificacion(true, "Prestador no disponible o turnos para estudios, seleccionar Especialidad", "amarillo");
      setTimeout(() => {
        history.push({ pathname: PORTAL_PATHS.RESERVAR_TURNO });
      }, 2000);
    } finally {
      setCargando(false);
    }
  };

  const toggleModalDetalleTurno = () => {
    setAbrirModalDetalleTurno(!abrirModalDetalleTurno);
  };

  const especialidadesVigentes = servicios
    .filter((esp) => esp.vigente === true)
    .map((esp) => ({ codigo: esp.codigo, nombre: esp.nombre }));

  return {
    cargando,
    paciente,
    setPaciente,
    turnoSeleccionado,
    abrirModalCancelarReserva,
    abrirComprobanteTurno,
    abrirModalDetalleTurno,
    listadoTurnos,
    prestadoresRecientes,
    estudios,
    servicios,
    toast,
    especialidadesVigentes,
    mostrarNotificacion,
    handleClickRedirigir,
    handleClickSeleccionarTurno,
    handleClickCancelarReserva,
    handleClickCopiarTelefono,
    handleClickComprobanteTurno,
    handleClickReservarTurnoPrestador,
    setAbrirModalCancelarReserva,
    toggleModalDetalleTurno,
    togleAbrirCerrarComprobanteTurno,
  };
};

export default useMainPage;
